import React, { useState, useEffect, useContext} from 'react';
import moment from 'moment';
import { useHttpClient } from '../../shared/hooks/http-hook';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../../shared/context/auth-context';
import { useParams, useHistory } from 'react-router-dom';
import { AppointmentSearchHeaders } from "../../dashboard/components/DashboardAppTableHeaders";
import Table from "../../shared/components/Table/Table";
import { formatDate } from "../../print/page/Print";
import Button from '../../shared/components/formElements/Button';
import { useWindow } from '../../shared/hooks/window-hook';

function SearchAppointments() {
    const { width } = useWindow();
    const startDate = useParams().startDate;
    const [endDate, setEndDate] = useState( useParams().endDate);
    const [customerName, setCustomerName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [numberOfMonths, setNumberOfMonths] = useState("1");

    const [loadedAppointments, setLoadedAppointments] = useState([]);
    const [filteredAppointment, setFilteredAppointment] = useState([])

    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const history = useHistory();
    const auth = useContext(AuthContext);

    const customerNameHandler = (e) => {
        setCustomerName(e.target.value)
    }


    const phoneNumberHandler = (e) => {
        setPhoneNumber(e.target.value)
    }
  

    const selectMonthsHandler = (e) => {
        setNumberOfMonths(e.target.value)
    }

    useEffect( () => {
        setEndDate()
        history.push(`/appointments/search/${startDate}/${moment(startDate).add(Number(numberOfMonths), 'months').format('YYYY-MM')}`);
        setEndDate(moment(startDate).add(Number(numberOfMonths), 'months').format('YYYY-MM'));
    }, [numberOfMonths, startDate, history])
    
    const submitHandler = async () => {
        if (customerName || phoneNumber) {
            try{
                const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+`/appointments/search/${startDate}/${endDate}`,
                "GET",
                null,
                {Authorization: 'Bearer '+ auth.token});
                setLoadedAppointments(responseData)
            } catch (err) {}         
        }
    }

    useEffect(() => {
        const filteredApps = loadedAppointments.map(subApp => {
            return ( 
                subApp.info.filter(app => app.type !== '')
                    .map(any => { return( {...any, ISOdate: subApp.date, date: formatDate(subApp.date.split('T')[0])} )})
            )
        }).reduce((flat, any) =>  flat.concat(any), [])
            .filter(app => app.customer.toLowerCase() === customerName.toLowerCase() || app.phone === phoneNumber)
            .map(app => {
                return({
                    ...app,
                    select : app.done ? '✔️' : '',
                    id: app._id
                })
            })
        setFilteredAppointment(filteredApps)

    }, [loadedAppointments, customerName, phoneNumber])

    const tableClickHandler = (id) => {
        const ISOdate = (filteredAppointment.find(app => app.id === id)).ISOdate;
        history.push(`/appointments/${ISOdate}`);    
    }

  return (
    <>
        {isLoading && (
          <div className="center">
            <LoadingSpinner />
          </div>
        )}
        
        <div className={width > 800 ? "flex justify-center ": ""}>
        {width < 800 ? <div className=" w-5 pa3 mr2">
                <Button to={`/appointments/${(moment().format('YYYY-MM-DD[T00:00:00.000Z]'))}`}>BACK</Button>
            </div> : "" }   
            <div className={width > 800 ? "outline w-25 pa3 mr2": "outline"}>
                <h2 className='ml4'>Search Appointment</h2>
                <div className="pa4 black-80 ">
                    <div className="measure">
                        <label htmlFor="name" className="f6 b db mb2">Customer Name <span className="normal black-60">(optional)</span></label>
                        <input 
                            id="name" 
                            className="input-reset ba b--black-20 pa2 mb2 db w-100" 
                            type="text" 
                            aria-describedby="name-desc"
                            value={customerName}
                            onChange={customerNameHandler}
                        />

                    </div>
                    
                    or<br/><br/>

                    <div className="measure">
                        <label htmlFor="name" className="f6 b db mb2">Phone Number <span className="normal black-60">(optional)</span></label>
                        <input 
                            id="name" 
                            className="input-reset ba b--black-20 pa2 mb2 db w-100" 
                            type="text" 
                            aria-describedby="name-desc"
                            value={phoneNumber}
                            onChange={phoneNumberHandler}
                        />
                    </div>

                    <select 
                        id="types" 
                        className="w-100 db h2 f6 bg-near-white ba b--sliver gray" 
                        name=""
                        value={numberOfMonths}
                        onChange={selectMonthsHandler}
                    >
                        <option label="This month" value="1">This month</option>
                        <option label="Next Two Months" value="2">Next Two Months</option>
                        <option label="Next three Months" value="3">Next three Months</option>
                        <option label="Next four Months" value="4">Next four Months</option>
                    </select>

                    <br/>
                    <button 
                        className="f6 link dim ph3 pv2 mb2 dib white bg-black"
                        onClick={submitHandler}                   
                    >SEARCH</button>

                </div>
            </div>
            <div className={width > 800 ? " w-40 pa3 mr2" : ""}>
                <Table 
                headers={AppointmentSearchHeaders}
                content={filteredAppointment}
                onclick={(id) => tableClickHandler(id)}
                custom
                />
            </div>
           {width > 800 ? <div className=" w-5 pa3 mr2">
                <Button to={`/appointments/${(moment().format('YYYY-MM-DD[T00:00:00.000Z]'))}`}>BACK</Button>
            </div> : "" }      
        </div>   
    </>
  )
}

export default SearchAppointments